import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const Text = makeShortcode("Text");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Examples`}</h2>
    <h3>{`Basic`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="flex" maxWidth="300px">
  <Box flexGrow={1} fontSize={2} fontWeight="bold" id="switchLabel">
    Notifications
  </Box>
  <ToggleSwitch aria-labelledby="switchLabel" />
</Box>
`}</code></pre>
    <h3>{`Uncontrolled with default value`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="flex" maxWidth="300px">
  <Box flexGrow={1} fontSize={2} fontWeight="bold" id="switchLabel">
    Notifications
  </Box>
  <ToggleSwitch defaultChecked aria-labelledby="switchLabel" />
</Box>
`}</code></pre>
    <h3>{`Controlled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "noinline live",
        "noinline": true,
        "live": true
      }}>{`const Controlled = () => {
  const [isOn, setIsOn] = React.useState(false)

  const onClick = () => {
    setIsOn(!isOn)
  }

  const handleSwitchChange = on => {
    console.log(\`new switch "on" state: \${on}\`)
  }

  return (
    <>
      <Box display="flex" maxWidth="300px">
        <Box flexGrow={1} fontSize={2} fontWeight="bold" id="switchLabel">
          Notifications
        </Box>
        <ToggleSwitch onClick={onClick} onChange={handleSwitchChange} checked={isOn} aria-labelledby="switchLabel" />
      </Box>
      <p>The switch is {isOn ? 'on' : 'off'}</p>
    </>
  )
}

render(Controlled)
`}</code></pre>
    <h3>{`Small`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="flex" maxWidth="300px">
  <Box flexGrow={1} fontSize={1} fontWeight="bold" id="switchLabel">
    Notifications
  </Box>
  <ToggleSwitch aria-labelledby="switchLabel" size="small" />
</Box>
`}</code></pre>
    <h3>{`Delayed toggle with loading state`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "noinline live",
        "noinline": true,
        "live": true
      }}>{`const LoadingToggle = () => {
  const [loading, setLoading] = React.useState(false)
  const [isOn, setIsOn] = React.useState(false)

  async function switchSlowly(currentOn) {
    await new Promise(resolve => setTimeout(resolve, 1500))
    return await !currentOn
  }

  async function onClick() {
    setLoading(!loading)
    const newSwitchState = await switchSlowly(isOn)
    setIsOn(newSwitchState)
  }

  const handleSwitchChange = React.useCallback(
    on => {
      setLoading(false)
    },
    [setLoading]
  )

  return (
    <>
      <Box display="flex" maxWidth="300px">
        <Box flexGrow={1} fontSize={2} fontWeight="bold" id="switchLabel">
          Notifications
        </Box>
        <ToggleSwitch
          aria-labelledby="switchLabel"
          loading={loading}
          checked={isOn}
          onClick={onClick}
          onChange={handleSwitchChange}
        />
      </Box>
      <p>The switch is {isOn ? 'on' : 'off'}</p>
    </>
  )
}

render(LoadingToggle)
`}</code></pre>
    <h3>{`Disabled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="flex" maxWidth="300px">
  <Box flexGrow={1} fontSize={2} fontWeight="bold" id="switchLabel">
    Notifications
  </Box>
  <ToggleSwitch aria-labelledby="switchLabel" disabled />
</Box>
`}</code></pre>
    <h3>{`With associated caption text`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="flex">
  <Box flexGrow={1}>
    <Text fontSize={2} fontWeight="bold" id="switchLabel" display="block">
      Notifications
    </Text>
    <Text color="fg.subtle" fontSize={1} id="switchCaption" display="block">
      Notifications will be delivered via email and the GitHub notification center
    </Text>
  </Box>
  <ToggleSwitch aria-labelledby="switchLabel" aria-describedby="switchCaption" />
</Box>
`}</code></pre>
    <h3>{`Left-aligned with label`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Text fontSize={2} fontWeight="bold" id="switchLabel" display="block" mb={1}>
    Notifications
  </Text>
  <ToggleSwitch statusLabelPosition="end" aria-labelledby="switchLabel" />
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="aria-describedby" type="string" description="The id of the DOM node that describes the switch" mdxType="PropsTableRow" />
  <PropsTableRow name="aria-labelledby" type="string" required description="The id of the DOM node that labels the switch" mdxType="PropsTableRow" />
  <PropsTableRow name="defaultChecked" type="boolean" description="Uncontrolled - whether the switch is turned on" mdxType="PropsTableRow" />
  <PropsTableRow name="disabled" type="boolean" description="Whether the switch is ready for user input" mdxType="PropsTableRow" />
  <PropsTableRow name="loading" type="boolean" description="Whether the switch's value is being calculated" mdxType="PropsTableRow" />
  <PropsTableRow name="checked" type="boolean" description="Whether the switch is turned on" mdxType="PropsTableRow" />
  <PropsTableRow name="onChange" type="(on: boolean) => void" description="The callback that is called when the switch is toggled on or off" mdxType="PropsTableRow" />
  <PropsTableRow name="onClick" type="(e: MouseEvent) => void" description="The callback that is called when the switch is clicked" mdxType="PropsTableRow" />
  <PropsTableRow name="size" type="'small' | 'medium'" defaultValue="'medium'" description="Size of the switch" mdxType="PropsTableRow" />
  <PropsTableRow name="statusLabelPosition" type="'start' | 'end'" defaultValue="'start'" description={<>
        <div>Whether the "on" and "off" labels should appear before or after the switch.</div>
        <div>
          <Text fontWeight="bold" mdxType="Text">This should only be changed when the switch's alignment needs to be adjusted.</Text>{' '}
          For example: It needs to be left-aligned because the label appears above it and the caption appears below it.
        </div>
      </>} mdxType="PropsTableRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      